import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import PendoLib, { LEARNER_API_KEY } from 'js/lib/pendo';
import { useParams } from 'js/lib/useRouter';
import { get, isAuthenticatedUser, isCourserian } from 'js/lib/user';

import EnterpriseSkillPathwayPageRootContent from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseSkillPathwayPageRootContent';
import EnterpriseSkillPathwayPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseSkillPathwayPageDataProvider';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterpriseOrgScopedPageTemplateWrapper from 'bundles/unified-common/providers/org-scoped/EnterpriseOrgScopedPageTemplateWrapper';
import EnterpriseOrgScopedModalManagerProvider from 'bundles/unified-common/providers/org-scoped/modals/EnterpriseOrgScopedModalManagerProvider';

const EnterpriseSkillPathwayPageRoot = () => {
  const { programSlug, orgSlug } = useParams();
  const isOrgScoped = Boolean(orgSlug);

  React.useEffect(() => {
    try {
      PendoLib.init(
        {
          visitor: {
            id: get().external_id,
            isLoggedIn: isAuthenticatedUser(),
            isCourserian: isCourserian(),
          },
          account: {
            isEnterprise: true,
            ...(isOrgScoped ? { slug: orgSlug ?? '' } : { programSlug: programSlug ?? '' }),
          },
        },
        LEARNER_API_KEY
      );
    } catch {
      // do nothing
    }
  }, [isOrgScoped, orgSlug, programSlug]);
  const content = <EnterpriseSkillPathwayPageRootContent />;
  return (
    <div data-testid="enterprise-skill-pathway-page">
      <EnterpriseSkillPathwayPageDataProvider>
        {isOrgScoped ? (
          <EnterpriseOrgScopedModalManagerProvider>
            <EnterpriseOrgScopedPageTemplateWrapper hideAdminImpersonationBanner>
              {content}
            </EnterpriseOrgScopedPageTemplateWrapper>
          </EnterpriseOrgScopedModalManagerProvider>
        ) : (
          <EnterprisePageTemplateWrapper>{content}</EnterprisePageTemplateWrapper>
        )}
      </EnterpriseSkillPathwayPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'enterprise_skill_pathway_description_page',
      page: 'enterprise_skill_pathway_page',
    },
  }))
)(EnterpriseSkillPathwayPageRoot);
